import { SERVICE } from "./global";

const PATH = {
  ITSUMONI: process.env.REACT_APP_MONITOR_IM_END_POINT,
  CLAP: process.env.REACT_APP_MONITOR_CW_END_POINT,
  AM: process.env.REACT_APP_MONITOR_AM_END_POINT,
  COMMON: process.env.REACT_APP_MONITOR_COMMON_END_POINT,

  TOP: "/",
  PROMOTION: "/promotions/:id",
  VIEW: "/promotion/view/:id",
  DETAIL_PROMOTION: "/entries/detail/:id",

  LOGIN: "/login",
  SIGNUP: `/signup?service=${SERVICE}`,

  FIRST: "/first",
  QUESTIONS: "/qa",
  GUIDE: "/guide",
  POINT: "/point",
  COMPANY: "/company",
  INFORMATION: "/privacy_policy",
  AGREEMENT: "/agreement",

  CONTACT: "/contact",
  CONTACT_CONFIRM: "/contact/confirm",
  CONTACT_DONE: "/contact/done",

  NEWS: "/news",
  NOTICE: "/news/detail_notice/:id",
  NEW: "/news/detail_new/:id",

  PAYMENT: "/payment",
  MY_POINT: "/mypoint",
  SETTING: "/setting",
  MEMBER_INFO: "/setting/view-info",
  CHANGE_EMAIL: "/setting/change-email",
  CHANGE_LOGIN: "/setting/change-login",
  ACCOUNT_INFO: "/setting/bank",
  PASSWORD: "/setting/password",
  ENTRIES: "/entries",

  AREA_LIST: "/place",
  AREA_DETAIL: "/place/:id",

  UPDATE_INFO: {
    EDIT: "/edit_information",
  },
  UPDATE_MAIL: {
    CHANGE: "/change_mail",
  },
  UPDATE_ID: {
    LOGIN: "/change-login",
    EMAIL: "/change-email",
  },
  UPDATE_BANK: {
    EDIT: "/bank",
  },
  UPDATE_PASSWORD: {
    UPDATE: "/change-password",
  },
  WITHDRAWAL: {
    CHECK: "/withdrawal",
  },

  ERROR_401: "401",
  ERROR_403: "403",
  ERROR_404: "404",
  ERROR_500: "500",
  ERROR_429: "429",
  ERROR_512: "512",
  PAGE_NOT_FOUND: "*",
};

export default PATH;
